
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getWalletTxPage, IWalletTx } from '@/api/walletRecord'
import { UserModule } from '@/store/modules/user'
import UserNameRemark from '@/components/UserNameRemark/index.vue'

@Component({
  name: 'WalletRecord',
  components: { UserNameRemark },
})
export default class extends Vue {
  private loading: boolean = false
  private list: IWalletTx[] = []
  private total: number = 0

  private query: {
    pageNum: number
    pageSize: number
    userPhone: string
    type: number | null
    payMethod: number | null
    status: number | null
  } = {
    pageNum: 1,
    pageSize: 10,
    userPhone: '',
    type: null,
    payMethod: null,
    status: null
  }

  get currentStoreId() {
    const sid = UserModule.storeId
    if (!sid) return null
    const n = Number(sid)
    return Number.isNaN(n) ? null : n
  }

  @Watch('currentStoreId')
  private onStoreChange() {
    this.query.pageNum = 1
    this.loadList()
  }

  mounted() {
    this.loadList()
  }

  private async loadList() {
    if (this.currentStoreId == null) {
      this.list = []
      this.total = 0
      return
    }
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        storeId: this.currentStoreId
      }
      if (this.query.userPhone) params.userPhone = this.query.userPhone.trim()
      if (this.query.type != null) params.type = this.query.type
      if (this.query.payMethod != null) params.payMethod = this.query.payMethod
      if (this.query.status != null) params.status = this.query.status

      const res: any = await getWalletTxPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || res.data.data.list || res.data.data.data || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } catch (e) {
      this.list = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() {
    this.query.pageNum = 1
    this.loadList()
  }

  private handleReset() {
    this.query.userPhone = ''
    this.query.type = null
    this.query.payMethod = null
    this.query.status = null
    this.query.pageNum = 1
    this.loadList()
  }

  private handleSizeChange(size: number) {
    this.query.pageSize = size
    this.loadList()
  }

  private handlePageChange(page: number) {
    this.query.pageNum = page
    this.loadList()
  }

  private formatDate(v?: string) {
    if (!v) return ''
    return String(v).replace('T', ' ').slice(0, 19)
  }
}
